import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
  Avatar,
  Typography,
  CircularProgress
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  AccountCircle as AccountCircleIcon
} from '@mui/icons-material';
import { RoleUtils } from '../../../types/enums';

const UserProfileMenu = ({
  anchorEl,
  open,
  onClose,
  user,
  userProfilePicture,
  defaultFacilityName,
  branding,
  loading,
  t,
  onNavigateToAccount,
  onLogout
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id="primary-search-account-menu"
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: 280,
          maxWidth: 350,
          mt: 1
        }
      }}
    >
      {/* User Information Section */}
      <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Avatar 
            src={userProfilePicture}
            sx={{ 
              bgcolor: branding.primaryColor,
              width: 48,
              height: 48,
              mr: 2
            }}
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : !userProfilePicture ? (
              user?.name ? user.name.charAt(0).toUpperCase() : <AccountCircleIcon />
            ) : null}
          </Avatar>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
              {user?.name || (user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : 'User')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
              {user?.email}
            </Typography>
          </Box>
        </Box>
        
        {/* Current Default Facility */}
        {defaultFacilityName && (
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
              Current Facility
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 500, color: 'primary.main' }}>
              {defaultFacilityName}
            </Typography>
          </Box>
        )}
        
        {/* User Roles */}
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            Roles
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500, textTransform: 'capitalize' }}>
            {RoleUtils.formatRolesForDisplay(user?.roles || [])}
          </Typography>
        </Box>
      </Box>
      
      {/* Menu Items */}
      <MenuItem onClick={onNavigateToAccount}>
        <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
        <ListItemText>{t('navigation.account')}</ListItemText>
      </MenuItem>
      <MenuItem onClick={onLogout}>
        <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
        <ListItemText>{t('navigation.logout')}</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default UserProfileMenu; 